import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  content: {
    paddingBottom: '5rem',
  },
  uploadButton: {
    marginTop: 'auto',
  },
  uploadsWrapper: {
    position: 'relative',
    backgroundColor: colors.neutral.white,
    borderRadius: '10px',
    margin: { bottom: '6.4rem', left: 'auto', right: 'auto' },
    padding: {
      top: '3.2rem',
      bottom: '3.2rem',
    },
    maxWidth: '109.6rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&:last-child': {
      marginBottom: '8rem',
    },
  },
  uploadFileWrapper: {
    width: '80%',
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'center',
    gap: '3rem',
    marginBottom: '8rem',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    gap: '3rem',
  },
  subtitleStyled: { margin: 0, maxWidth: '61.2rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
